import { c as _c } from "react/compiler-runtime";
import { DevFeaturesDialogButton } from "@components/dev-features-dialog/dev-features-dialog-button";
import { FaroHelpCenterMenu } from "@components/header/faro-help-center-menu";
import { Searchbar } from "@components/header/searchbar";
import { UserMenu } from "@components/header/user-menu";
import { ProgressOverviewMenu } from "@components/progress-overview/progress-overview-menu";
import { useMediaQueryList } from "@hooks/use-media-query";
import { Grid } from "@mui-wrapper";
import { useAppSelector } from "@store/store-helper";
import { loggedInUserSelector } from "@store/user/user-selector";
/** Content for the right side of layout header */
export function HeaderLayoutRight(t0) {
  const $ = _c(19);
  const {
    shouldShowProgressOverviewMenu,
    shouldShowUserMenu,
    shouldShowSearchbar
  } = t0;
  const {
    isScreenSmOrSmaller
  } = useMediaQueryList();
  const loggedInUser = useAppSelector(loggedInUserSelector);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      alignItems: "center",
      justifyContent: "right"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== shouldShowSearchbar) {
    t2 = shouldShowSearchbar && <Searchbar variant="filled" />;
    $[1] = shouldShowSearchbar;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = isScreenSmOrSmaller ? "0.25rem" : "1rem";
  let t4;
  if ($[3] !== t3) {
    t4 = {
      alignItems: "center",
      gap: t3
    };
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <DevFeaturesDialogButton />;
    t6 = <FaroHelpCenterMenu />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] !== loggedInUser || $[8] !== shouldShowProgressOverviewMenu) {
    t7 = shouldShowProgressOverviewMenu && loggedInUser && <ProgressOverviewMenu />;
    $[7] = loggedInUser;
    $[8] = shouldShowProgressOverviewMenu;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== shouldShowUserMenu) {
    t8 = shouldShowUserMenu && <UserMenu />;
    $[10] = shouldShowUserMenu;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t4 || $[13] !== t7 || $[14] !== t8) {
    t9 = <Grid container={true} sx={t4}>{t5}{t6}{t7}{t8}</Grid>;
    $[12] = t4;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t2 || $[17] !== t9) {
    t10 = <Grid container={true} sx={t1}>{t2}{t9}</Grid>;
    $[16] = t2;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
}